<template>
    <div class="login-layout">
        <section class="login-panel">
            <div class="login-panel-content">
                <div class="login-header">
                    <img src="../assets/logoAiConsumer.png" class="login-logo" alt="Logo AiConsumer">
                </div>

                <form class="login-form" @submit.prevent="signin">
                    <div class="input-group">
                        <span class="input-icon mdi mdi-email" aria-hidden="true"></span>
                        <input
                            id="email"
                            v-model="user.email"
                            class="login-input"
                            type="email"
                            name="email"
                            placeholder=" "
                            autocomplete="username"
                            required
                            aria-label="E-mail de login"
                        >
                        <label class="floating-label" for="email">E-mail</label>
                    </div>

                    <div class="input-group">
                        <span class="input-icon mdi mdi-lock" aria-hidden="true"></span>
                        <input
                            id="password"
                            v-model="user.password"
                            class="login-input with-toggle"
                            :type="show1 ? 'text' : 'password'"
                            name="password"
                            placeholder=" "
                            autocomplete="current-password"
                            required
                            aria-label="Senha de login"
                            @keydown.enter="signin"
                        >
                        <label class="floating-label" for="password">Senha</label>
                        <button
                            type="button"
                            class="toggle-password mdi"
                            :class="show1 ? 'mdi-eye-off' : 'mdi-eye'"
                            aria-label="Mostrar ou ocultar senha"
                            @click="show1 = !show1"
                        ></button>
                    </div>

                    <button
                        v-if="!usuarioLogado"
                        class="login-button"
                        type="submit"
                        :disabled="loading"
                        aria-label="Entrar no sistema"
                    >
                        {{ loading ? "ACESSANDO..." : "ACESSAR" }}
                    </button>
                </form>

                <div class="footer-area">
                    <p class="copyright-text">Todos os direitos reservados Intelite Tecnologia ® 2026</p>
                </div>
            </div>
        </section>

        <aside class="banner-panel"></aside>

        <Snackbar ref="chamaSnackbar" />
    </div>
</template>

<script>
    import { userKey, baseApiUrl } from '@/global'
    import Snackbar from '../componentes/snackbar.vue'
    import { mapState } from 'vuex'
    import axios from 'axios'
    export default {
        components: {Snackbar},
        name: 'Auth',
        computed: mapState({
            usuarioLogado: state => state.isMenuVisible,
        }),
        data: function() {
            return {
                loading: false,
                countAccess: '',
                userObj: [],
                show1: false,
                token: "",
                userId: "",
                showSignup: false,
                showAlterPass: false,
                userPemission: "",
                user: {},
                emailRules: [
                    v => !!v || 'E-mail é obrigatório',
                    v => /.+@.+/.test(v) || 'E-mail não é válido'
                ],
                nameRules: [
                    v => !!v || 'Nome é obrigatório'
                ],
                passwordRules: [
                    v => !!v || 'Senha é obrigatório'
                ]         
            }
        },

        mounted: function () {
            if (sessionStorage.getItem('accToken') != null) {
                if (sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).ativo == true) {
                    if (JSON.parse(sessionStorage.getItem('user')).tipo == 'GERENTE' || JSON.parse(sessionStorage.getItem('user')).tipo == 'ADMIN' || JSON.parse(sessionStorage.getItem('user')).tipo == 'ADMIN_LOJISTA'  || JSON.parse(sessionStorage.getItem('user')).tipo == 'ADMIN_PRODUTORA') {
                        this.$router.push({ path: '/home' })
                    } else if (JSON.parse(sessionStorage.getItem('user')).tipo == 'CAIXA') {
                        this.$router.push({ path: '/caixa' })
                    } else if (JSON.parse(sessionStorage.getItem('user')).tipo == 'ATENDENTE') {
                        this.$router.push({ path: '/lojista' })
                    }
                } else {
                    this.$router.push({ path: '/home' })
                }
            }
            if (sessionStorage.getItem('userPermission') != null)
                this.$store.dispatch('Permission')
            if (sessionStorage.getItem('accToken') != null)
                this.$store.dispatch('Logar', this.token)
            
            this.pegaParametrosUrl()
        },

        methods: {
            async signin() {
                this.loading = true
                if ((this.user.email != null) || (this.user.password != null)) {
                    await axios.post(`${baseApiUrl}Usuarios/login`, this.user)
                    .then(response => {
                        this.token = response.data.id
                        this.userId = response.data.userId
                        this.verificaUsuario()
                    })
                    .catch(() => {
                        this.loading = false  
                        var vm = this;          
                        vm.$refs.chamaSnackbar.snack("#EF5350","Usuário e senha inválidos. Corrija e tente novamente!","ERRO")
                    })
                } else {
                    this.loading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Preencha os campos de E-mail e Senha!","ATENÇÃO")
                }
            },

            Sair() {
                this.$store.dispatch('Sair')
            },

            async verificaUsuario() {
                var vm = this;
                if (this.userId != '') {
                    await axios.get(`${baseApiUrl}Usuarios/${this.userId}?access_token=${this.token}`)
                    .then(res => {
                        if (res.data) {
                            sessionStorage.setItem('accToken', this.token)
                            this.userPemission = res.data.tipo
                            this.user.username = res.data.nome
                            this.userObj = res.data
                            sessionStorage.setItem(userKey, JSON.stringify(this.userPemission))
                            sessionStorage.setItem('userPermission', this.userPemission)
                            sessionStorage.setItem('userName', this.user.username)
                            sessionStorage.setItem('user', JSON.stringify(res.data))
                            sessionStorage.setItem('email', this.user.email)
                            sessionStorage.setItem('password', this.user.password)
                            this.$store.dispatch('SetUser')
                            this.$store.dispatch('Permission')
                            this.$store.dispatch('SetUserName')
                            this.$store.dispatch('Logar', this.token)
                            this.verificaLojista(res.data.lojistaId)
                            this.verificaCompany()
                            if (res.data.tipo === "GERENTE" || res.data.tipo === "ADMIN" || res.data.tipo === 'ADMIN_LOJISTA' || res.data.tipo === 'ADMIN_PRODUTORA' && res.data.ativo === true) {
                                this.$router.push({ path: '/home' })
                            } else if (res.data.tipo == 'CAIXA' && res.data.ativo == true) {
                                this.$router.push({ path: '/caixa' })
                            } else if (res.data.tipo == 'ATENDENTE' && res.data.ativo == true) {
                                this.$router.push({ path: '/lojista' })
                            } else {
                                sessionStorage.clear()
                                this.loading = false
                                vm.$refs.chamaSnackbar.snack("#F9A825","Usuário inativo ou sem permissão de acesso!", "ATENÇÃO")
                            }
                        }
                    })
                    .catch(() => {
                        //
                    })
                }
            },
                
            verificaCompany() {
                axios.get(`${baseApiUrl}Empresas?filter[where][id]=${this.userObj.empresaId}&access_token=${this.token}`)
                .then(res => {
                    sessionStorage.setItem('company', JSON.stringify(res.data[0]))
                    this.$store.dispatch('SetCompany')
                    this.loading = false
                })
                .catch(() => {
                    this.loading = false
                    var vm = this
                    vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao consultar empresa", "DESCULPE")
                })
            },

            verificaLojista(id) {
                axios.get(baseApiUrl + 'Lojistas/' + id + '?access_token=' + this.token)
                .then(response => {
                    sessionStorage.setItem('lojista', JSON.stringify(response.data))
                    this.$store.dispatch('SetLojista')
                })
            },

            pegaParametrosUrl() {
                let params = window.location.search.substring(1).split('&');

                if (params[0] != '') {
                    let paramArray = {};                            // Criar objeto que vai conter os parametros

                    for (var i = 0; i < params.length; i++) {       // Passar por todos os parametros
                        var param = params[i].split('=');           // Dividir os parametros chave e valor
                        paramArray[param[0]] = param[1];            // Adicionar ao objeto criado antes
                    }

                    if (paramArray['e'] && paramArray['p']) {
                        this.user.email = paramArray['e'].replace('%40','@')
                        this.user.password = paramArray['p']
                        this.signin()
                    }
                }
            },
        }
    }
</script>

<style>
    .login-layout {
        min-height: 100vh;
        display: flex;
        background-color: #ffffff;
    }

    .login-panel {
        width: 100%;
        max-width: 481px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 42px 38px;
        position: relative;
        z-index: 2;
    }

    .login-panel-content {
        width: 100%;
        max-width: 330px;
    }

    .login-header {
        text-align: center;
        margin-bottom: 18px;
    }

    .login-logo {
        width: 230px;
        max-width: 100%;
        margin-bottom: 0;
    }

    .login-form {
        width: 100%;
    }

    .input-group {
        position: relative;
        margin-bottom: 14px;
    }

    .input-icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #7f8798;
        font-size: 15px;
        pointer-events: none;
    }

    .login-input {
        width: 100%;
        height: 44px;
        border: 1px solid #c7cfdf;
        border-radius: 4px;
        padding: 0 12px 0 36px;
        font-size: 13px;
        color: #2a3347;
        background: #f2f5fb;
        outline: none;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .login-input:focus {
        border-color: #283275;
        box-shadow: 0 0 0 1px #283275;
    }

    .floating-label {
        position: absolute;
        left: 36px;
        top: 50%;
        transform: translateY(-50%);
        color: #8b93a3;
        font-size: 12px;
        line-height: 1;
        padding: 0 4px;
        background: #f2f5fb;
        pointer-events: none;
        transition: all 0.18s ease;
    }

    .login-input:focus + .floating-label,
    .login-input:not(:placeholder-shown) + .floating-label {
        top: 0;
        transform: translateY(-50%);
        font-size: 10px;
        color: #283275;
    }

    .with-toggle {
        padding-right: 38px;
    }

    .toggle-password {
        position: absolute;
        right: 11px;
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        color: #7f8798;
        font-size: 17px;
        cursor: pointer;
        padding: 0;
    }

    .login-button {
        width: 100%;
        height: 42px;
        margin-top: 10px;
        border: none;
        border-radius: 6px;
        background: linear-gradient(135deg, #1f2e81, #283275);
        color: #fff;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.6px;
        cursor: pointer;
        transition: filter 0.2s ease;
    }

    .login-button:hover {
        filter: brightness(1.05);
    }

    .login-button:disabled {
        opacity: 0.75;
        cursor: not-allowed;
    }

    .footer-area {
        display: flex;
        justify-content: center;
        margin-top: 14px;
    }

    .copyright-text {
        margin: 0;
        font-size: 11px;
        color: #75829a;
        white-space: nowrap;
    }

    .banner-panel {
        flex: 1;
        background-image: url("../assets/background.png");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    .login-button:focus {
        outline: 2px solid #8ea6ff;
        outline-offset: 2px;
    }

    @media (max-width: 1024px) {
        .login-panel {
            max-width: 100%;
        }

        .banner-panel {
            display: none;
        }
    }
</style>
